import { connect } from 'react-redux';
import ChatFlowDiagramComponent from '../../Components/ChatFlows/ChatFlowDiagram';

const mapStateToProps = (state) => {
  return {
    st_ChatFlows: state.reducer.CHAT_FLOWS,
    st_CallFlows: state.reducer.CALL_FLOWS,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    Token: state.reducer.Token,
    SCOPES: state.reducer.SCOPES_NAMES,
  };
};

const ChatFlowDiagramContainer = connect(mapStateToProps)(ChatFlowDiagramComponent);

export default ChatFlowDiagramContainer;
